import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import * as bs from 'bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: '[app-item-bill]',
  template: `
    <td># {{bill?.id}}</td>
    <td>{{bill?.reference}}</td>
    <td>{{bill?.unit?.name}} - {{bill?.settlement.name}}</td>
    <td>{{bill?.created_at | date: 'dd/MM/yy'}}</td>
    <td>{{bill?.total | currency}}</td>
    <td>
      <div class="badge rounded-pill bg-danger py-2 px-2" *ngIf="bill.date_status==='expirado'" placement="bottom" ngbTooltip="Este recibo expiró, ya no se puede pagar.">
        <fa-icon [icon]="icons.faCircleExclamation" style="font-size: 12px;" ></fa-icon>
        Expirado
      </div>
      <div class="badge rounded-pill bg-warning py-2 px-2" *ngIf="bill.date_status==='vencido'" placement="bottom" ngbTooltip="Este recibo no ha sido pagado aún, puede generar intereses por falta de pago.">
        <fa-icon [icon]="icons.faTriangleExclamation" style="font-size: 12px;"></fa-icon>
        Vencido
      </div>
      <div class="badge rounded-pill bg-info py-2 px-2" *ngIf="bill.date_status==='verify'" placement="bottom" ngbTooltip="Este recibo no ha sido pagado aún, puede generar intereses por falta de pago.">
        <fa-icon [icon]="icons.faSpinner" style="font-size: 12px;"></fa-icon>
        En validación
      </div>
      <div class="badge rounded-pill bg-info py-2 px-2" *ngIf="bill.date_status==='pendiente'" placement="bottom" ngbTooltip="Este recibo no ha sido pagado aún, puede generar intereses por falta de pago.">
        <fa-icon [icon]="icons.faSpinner" style="font-size: 12px;"></fa-icon>
        Pendiente
      </div>
    </td>
    <td>
      <button class="btn btn-zazz-default ms-2" (click)="gotoPayment(bill)"> <!-- *ngIf="this.bill.date_status!='expirado'" -->
        <fa-icon [icon]="icons.faCashRegister" class="m-1"></fa-icon>
        Pagar
      </button>
    </td>
    <!-- div class="d-none d-sm-block">
      <div class="row">
        <div class="col-12 col-sm-2 text-center mt-0 mt-sm-2">
          <p class="mb-0">
            <span class="text-danger" *ngIf="bill?.attributes?.consumo_lt < 0"><fa-icon [icon]="icons.faCircleExclamation"></fa-icon></span>
            {{bill.consumo_lt | number: '1.2-2'}} Lts.
          </p>
        </div>
      </div>
    </div -->
    
    <!-- app-modal-options-pay [bill]="bill" (billData)="payBill($event)"></!-->
    <app-modal-bill-verify [bill]="bill" (billData)="updateBill($event)"></app-modal-bill-verify>
  `,
  styleUrls: []
})
export class ItemBillComponent implements OnInit {
  @Input() bill: any;
  @Input() profile: any;
  @Input() permissions: any;
  @Output() selectBill: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("btnOptionsPay", { read: ElementRef, static: false }) btnOptionsPay !: ElementRef;
  storageService = inject(StorageService);
  receiptUrl: string = environment.RECIBOS_REST_WSPREFIX;

  lsUser: any = sessionStorage.getItem(STORAGE_KEYS.USER);
  user: any = this.lsUser != null ? JSON.parse(this.lsUser) : null;

  settlement: any = null;
  can_pay: boolean = false;

  constructor(
    private route: Router,
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService
  ) { }

  checkPermissions() {
    switch (this.user.role_id) {
      case 1:
        this.can_pay = false;
        break;
      case 2:
        this.can_pay = false;
        break;
      case 4:
        this.can_pay = true;
        break;
      default:
        this.can_pay = false;
        break;
    }
  }

  ngOnInit(): void {
    this.checkPermissions();

    const due_date = new Date(this.bill.due_date);
    const today = new Date();

    /* let expiredDate = new Date(due_date.getFullYear(), due_date.getMonth()+1, 0);
    expiredDate.setDate(expiredDate.getDate() - 3); */

    if (this.bill.state === 3) {
      this.bill.date_status = 'verify';
    } else {
      if (due_date >= today) {
        this.bill.date_status = this.bill.status ? '' : 'pendiente';
      } else if (due_date < today) {
        this.bill.date_status = 'vencido';
      }
    }
  }

  verificationBill() {
    new bs.Modal(<HTMLInputElement>document.getElementById('modalBillVerify')).show();
  }

  

  updateBill(bill: any) {
    this.store.uploadReceipt(bill.id, bill).subscribe({
      next: (data: any) => {
        this.toastr.success('Recibo actualizado correctamente.');
      },
      error: (error: any) => {
        this.toastr.error('Error al actualizar el recibo.');
      }
    });
  }

  dispatchPayment() {
    this.selectBill.emit(this.bill);
  }

  payBill(bill: any) {

    
    return;
    this.store.createTransaction(bill).subscribe({
      next: (data: any) => {
        this.toastr.success('Recibo creado correctamente.', 'Éxito');
        // this.loading = false;
        console.log('DATA', data);
        // this.route.navigate(['/pagos/pendientes']);
        // window.location.reload();

      },
      error: (err: any) => {
        this.toastr.error('Ocurrió un error al crear el recibo', 'Error');
        // this.loading = false;
      }
    });
  }

  gotoPayment(bill: any) {
    this.route.navigate(['/tenant/bill', bill.id]);
  }

  unpublishBill() {
    this.store.unpublishBill(this.bill.id).subscribe({
      next: (data: any) => {
        this.toastr.success('Recibo despublicado correctamente.', 'Éxito');
        this.route.navigate([`/pagos/recibos/${this.bill.id}`]);
      },
      error: (err: any) => {
        this.toastr.error('Ocurrió un error al despublicar el recibo', 'Error');
      }
    });
  }

  downloadReceipt() {
    const link = document.createElement('a');
    link.href = `${this.receiptUrl}/public/${this.bill.pdf}`;
    link.download = this.bill.pdf;
    // link.click();
    window.open(`${this.receiptUrl}/public/${this.bill.pdf}`, '_blank')!.focus();
    // href="{{receiptUrl}}/public/{{bill.pdf}}" 
  }

  
}